export const FilterSelectAttributeAttempt = 'FilterSelectAttributeAttempt'
export const FilterSelectAttempt = 'FilterSelectAttempt'
export const FilterSelectBegin = 'FilterSelectBegin'
export const FilterSelectCancel = 'FilterSelectCancel'
export const FilterSelectFail = 'FilterSelectFail'
export const FilterSelectReset = 'FilterSelectReset'
export const FilterSelectSuccess = 'FilterSelectSuccess'
